import { createAction } from "redux-starter-kit";

import { LOGOUT } from "../types";

const logout = createAction(LOGOUT);

export default logout;
